module.exports = global["dust"] = require("-!/walletexpnodeweb-ci-6534/workspace/consumerweb-release/node_modules/dustjs-linkedin/lib/dust.js");


//////////////////
// WEBPACK FOOTER
// /walletexpnodeweb-ci-6534/workspace/consumerweb-release/~/dustjs-linkedin/lib/dust.js
// module id = 13
// module chunks = 0